import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Textarea } from "V2.0/common/textarea";
import { Listbox, ListboxOption, ListboxLabel } from "V2.0/common/listbox";
import { Switch } from "V2.0/common/switch";

import { WaitForCallbackExpectedFieldType } from "../../../Models/WaitForCallback";

export default WaitForCallbackExpectedFieldForm;

function WaitForCallbackExpectedFieldForm(props) {
  const { formState, updateFormState, errors } = props;

  return (
    <div className="space-y-4">
      <Field>
        <Label>Field Name *</Label>
        <Input
          type="text"
          value={formState.fieldName}
          onChange={(e) => updateFormState("fieldName", e.target.value)}
          invalid={!!errors.fieldName}
        />
        {errors.fieldName && <ErrorMessage>{errors.fieldName}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Description</Label>
        <Textarea
          rows={3}
          value={formState.description}
          style={{ fontSize: "13px" }}
          onChange={(e) => updateFormState("description", e.target.value)}
        />
      </Field>

      <Field>
        <Label>Field Type</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.fieldType}
          defaultValue={formState.fieldType}
          onChange={(value) => updateFormState("fieldType", value)}
        >
          {Object.values(WaitForCallbackExpectedFieldType).map((type) => {
            return (
              <ListboxOption
                key={type}
                value={type}
              >
                <ListboxLabel>{type}</ListboxLabel>
              </ListboxOption>
            );
          })}
        </Listbox>
      </Field>

      <Field className=" space-x-2">
        <Label>Required Field</Label>
        <Switch
          color="emerald"
          checked={formState.isRequired}
          onChange={() => updateFormState("isRequired", !formState.isRequired)}
        />
      </Field>
    </div>
  );
}
